import { getApi } from "@beeldit/core/helpers/api";

async function replicateInvoice(invoiceId: number | string, onSuccess: (newInvoiceId: number) => void) {
  try {
    const response = await getApi().post(
      `/invoices/${invoiceId}/replicate`
    );
    
    const newInvoice = response.data;
    console.log("Invoice replicated:", newInvoice);
    
    // Llamar al callback con el ID de la nueva factura
    onSuccess(newInvoice.id);
  } catch (error: any) {
    console.error("Error replicating invoice:", error);
    alert(error.response?.data?.message || "Error al copiar la factura");
  }
}

export default replicateInvoice;
